import { AlertCircleIcon, InfoIcon, StarIcon } from 'lucide-react-native';
import { XStack, YStack } from 'tamagui';

import { BadgeAction, BadgeLabel } from '../../components/badges/Badge';
import {
    BodyLargeEmphasized,
    BodyMediumRegular,
    H5Emphasized,
    LabelRegular,
} from '../../components/text/Typography';

export const Badges = () => {
    return (
        <YStack gap="$6">
            <YStack gap="$4">
                <H5Emphasized>BadgeLabel (Non-interactive)</H5Emphasized>
                <BodyMediumRegular>
                    Static labels used to indicate status, properties, or
                    categories. Non-interactive.
                </BodyMediumRegular>

                <BodyLargeEmphasized>Semantic Variants</BodyLargeEmphasized>
                <YStack>
                    <LabelRegular>Regular</LabelRegular>
                    <XStack
                        gap={8}
                        padding="$1"
                        flexWrap="wrap"
                        alignItems="center"
                    >
                        <BadgeLabel
                            variant="neutral"
                            text="Neutral"
                            icon={InfoIcon}
                            size="regular"
                        />
                        <BadgeLabel
                            variant="positive"
                            text="Positive"
                            icon={InfoIcon}
                            size="regular"
                        />
                        <BadgeLabel
                            variant="warning"
                            text="Warning"
                            icon={AlertCircleIcon}
                            size="regular"
                        />
                        <BadgeLabel
                            variant="danger"
                            text="Danger"
                            icon={AlertCircleIcon}
                            size="regular"
                        />
                    </XStack>
                    <LabelRegular marginTop={8}>Large</LabelRegular>
                    <XStack
                        gap={8}
                        marginBottom={8}
                        padding="$1"
                        flexWrap="wrap"
                        alignItems="center"
                    >
                        <BadgeLabel
                            variant="neutral"
                            text="Neutral"
                            icon={InfoIcon}
                            size="large"
                        />
                        <BadgeLabel
                            variant="positive"
                            text="Positive"
                            icon={InfoIcon}
                            size="large"
                        />
                        <BadgeLabel
                            variant="warning"
                            text="Warning"
                            icon={AlertCircleIcon}
                            size="large"
                        />
                        <BadgeLabel
                            variant="danger"
                            text="Danger"
                            icon={AlertCircleIcon}
                            size="large"
                        />
                    </XStack>
                </YStack>
                <BodyLargeEmphasized>Non-Semantic Variants</BodyLargeEmphasized>
                <YStack>
                    <LabelRegular>Regular</LabelRegular>
                    <XStack
                        gap={8}
                        padding="$1"
                        flexWrap="wrap"
                        alignItems="center"
                    >
                        <BadgeLabel variant="gray" text="Gray" size="regular" />
                        <BadgeLabel variant="blue" text="Blue" size="regular" />
                        <BadgeLabel
                            variant="green"
                            text="Green"
                            size="regular"
                        />
                        <BadgeLabel
                            variant="marigold"
                            text="Marigold"
                            size="regular"
                        />
                    </XStack>
                    <LabelRegular marginTop={8}>Large</LabelRegular>
                    <XStack
                        gap={8}
                        marginBottom={8}
                        padding="$1"
                        flexWrap="wrap"
                        alignItems="center"
                    >
                        <BadgeLabel variant="gray" text="Gray" size="large" />
                        <BadgeLabel variant="blue" text="Blue" size="large" />
                        <BadgeLabel variant="green" text="Green" size="large" />
                        <BadgeLabel
                            variant="marigold"
                            text="Marigold"
                            size="large"
                        />
                    </XStack>
                </YStack>
                <BodyLargeEmphasized>On a gray surface</BodyLargeEmphasized>
                <BodyMediumRegular>
                    Use neutral-alt on $gray200 surfaces, where neutral blends
                    into the background.
                </BodyMediumRegular>
                <XStack
                    gap={8}
                    padding={16}
                    borderRadius={16}
                    backgroundColor="$gray200"
                    flexWrap="wrap"
                    alignItems="center"
                >
                    <BadgeLabel
                        variant="neutral"
                        text="Neutral"
                        size="regular"
                    />
                    <BadgeLabel
                        variant="neutral-alt"
                        text="Neutral Alt"
                        size="regular"
                    />
                    <BadgeLabel
                        variant="neutral-alt"
                        text="Neutral Alt"
                        icon={InfoIcon}
                        size="large"
                    />
                </XStack>
            </YStack>

            <YStack gap="$4">
                <H5Emphasized>BadgeAction (Interactive)</H5Emphasized>
                <BodyMediumRegular>
                    Interactive badges that can be clicked or tapped. Always
                    requires onPress. Only one size.
                </BodyMediumRegular>

                <BodyLargeEmphasized>With Icons</BodyLargeEmphasized>
                <XStack gap={8} marginBottom={8} padding="$1" flexWrap="wrap">
                    <BadgeAction
                        variant="neutral"
                        text="Neutral"
                        icon={StarIcon}
                    />
                    <BadgeAction
                        variant="primary"
                        text="Primary"
                        icon={StarIcon}
                    />
                    <BadgeAction
                        variant="warning"
                        text="Warning"
                        icon={StarIcon}
                    />
                    <BadgeAction
                        variant="danger"
                        text="Danger"
                        icon={StarIcon}
                    />
                    <BadgeAction
                        variant="neutral"
                        text="Disabled"
                        icon={StarIcon}
                        disabled={true}
                    />
                </XStack>

                <BodyLargeEmphasized>Without Icons</BodyLargeEmphasized>
                <XStack gap={8} marginBottom={8} padding="$1" flexWrap="wrap">
                    <BadgeAction variant="neutral" text="Neutral" />
                    <BadgeAction variant="primary" text="Primary" />
                    <BadgeAction variant="warning" text="Warning" />
                    <BadgeAction variant="danger" text="Danger" />
                    <BadgeAction
                        variant="neutral"
                        text="Disabled"
                        disabled={true}
                    />
                </XStack>
            </YStack>
        </YStack>
    );
};
